import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'

import bgImage from './components/bg-image/bg-image'

import {
  galleryOptions
} from './imports/fancyOptions'

Vue.component('ProductSlider', {
  components: {
    swiper,
    swiperSlide,
    bgImage
  },
  props: ['galleryp'],
  data() {
    return {
      gallery: this.galleryp,
      options: {
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        autoHeight: true,
        mousewheel: true,
        pagination: {
          el: '.slider-pagination',
          type: 'fraction', //"bullets", "fraction", "progressbar" or "custom"
          formatFractionCurrent: function (number) {
            return '0' + number;
          },
          formatFractionTotal: function (number) {
            return '0' + number;
          },
          renderFraction: function (currentClass, totalClass) {
            return `
              <p class="xxxsmall">
                <span class="text-orange ' + ${currentClass} + '">01</span>
                <span>/</span>
                <span class="' + ${totalClass} + '">08</span>
              </p>
            `;
          }
        },
        navigation: {
          nextEl: '.btn-slider-next',
          prevEl: '.btn-slider-prev',
        },
        breakpoints: {
          767: {
            mousewheel: false,
          },
          575: {
            direction: 'horizontal',
            slidesPerView: 1.5,
            allowTouchMove: true,
            mousewheel: false,
            autoHeight: false,
            // spaceBetween: 10
          },
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.swiper
    }
  },
  methods: {
    sliderClicked(event) {
      if (
        !event.target.classList.contains('icon-arrow-tail-up') &&
        !event.target.classList.contains('icon-arrow-tail-down')
      ) {
        window.jQuery.fancybox.open(this.gallery, galleryOptions, this.swiper.realIndex + 1);
      }
    }
  },
  mounted() {
    this.$root.$on('click-parent', this.clickParent);
  }
})


// WEBPACK FOOTER //
// ./src/js/products-inner.js